__turbopack_context__.v({
  "animate": "_-module__Enouwa__animate",
  "fade-in": "_-module__Enouwa__fade-in",
  "title": "_-module__Enouwa__title",
});
